import { render, staticRenderFns } from "./detailsTable.vue?vue&type=template&id=70ae4a04&scoped=true&"
import script from "./detailsTable.vue?vue&type=script&lang=js&"
export * from "./detailsTable.vue?vue&type=script&lang=js&"
import style0 from "./detailsTable.vue?vue&type=style&index=0&id=70ae4a04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae4a04",
  null
  
)

export default component.exports